import React from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface FilterBarProps {
  startDate: Date;
  endDate: Date;
  serviceType: string;
  gstFilter: string;
  isSuperAdmin?: boolean;
  onStartDateChange: (date: Date) => void;
  onEndDateChange: (date: Date) => void;
  onServiceTypeChange: (value: string) => void;
  onGstFilterChange: (value: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  startDate,
  endDate,
  serviceType,
  gstFilter,
  isSuperAdmin = false,
  onStartDateChange,
  onEndDateChange,
  onServiceTypeChange,
  onGstFilterChange,
}) => (
  <Paper
    sx={{
      p: { xs: 2, md: 2.5 },
      mb: { xs: 2.5, md: 3 },
      borderRadius: '18px',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      background: 'linear-gradient(135deg, var(--primary-light), #ffffff)',
      boxShadow: '0 6px 18px rgba(0,0,0,0.06)',
    }}
  >
    <Grid container spacing={2.5} alignItems="center">
      <Grid item xs={12} md={6}>
        <Typography
          variant="subtitle2"
          sx={{ textTransform: 'uppercase', letterSpacing: 0.8, mb: 1 }}
        >
          Date range
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 1.5,
            mb: 1,
            flexWrap: 'wrap',
            zIndex: 1,
          }}
        >
          <DatePicker
            selected={startDate}
            onChange={(date) => date && onStartDateChange(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            className="date-picker"
          />
          <DatePicker
            selected={endDate}
            onChange={(date) => date && onEndDateChange(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            className="date-picker"
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 1,
            alignItems: { xs: 'stretch', sm: 'center' },
            flexWrap: 'wrap',
            zIndex: 2,
          }}
        >
          <FormControl
            size="small"
            fullWidth
            sx={{ width: { xs: '100%', sm: 180, md: 200 } }}
          >
            <InputLabel id="service-type-label">Service Type</InputLabel>
            <Select
              labelId="service-type-label"
              id="service-type-select"
              size="small"
              value={serviceType}
              label="Service Type"
              onChange={(e) => onServiceTypeChange(e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="food">Food Service</MenuItem>
              <MenuItem value="room">Room Service</MenuItem>
            </Select>
          </FormControl>
          {isSuperAdmin && (
            <FormControl
              size="small"
              fullWidth
              sx={{ width: { xs: '100%', sm: 180, md: 200 } }}
            >
              <InputLabel id="gst-filter-label">Filter</InputLabel>
              <Select
                labelId="gst-filter-label"
                id="gst-filter-select"
                size="small"
                value={gstFilter}
                label="Filter"
                onChange={(e) => onGstFilterChange(e.target.value)}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="gst">GST</MenuItem>
                <MenuItem value="test-bills">Test-Bills</MenuItem>
              </Select>
            </FormControl>
          )}
        </Box>
      </Grid>
    </Grid>
  </Paper>
);

export default FilterBar;
